export default {

  SFExpressStatus: ['已取消', '待取件', '已取件', '已签收', '已取消待退款'],

  /**
   * 将申请人的资料分类
   * @desc 资料核对页按职业身份展示所有人所需的资料详情，每类身份展示所有人的姓名
   * @param {Object} order 订单
   * @memberof SFService
   */
  classfiyMaterials(order) {
    if (!order) return {};
    const me = this;
    const applicantIdentityAndIndexMap = {};
    const classifiedApplicants = [];

    if (order.applicant && order.applicant.length > 0) {
      // 遍历数组进行分类
      order.applicant.forEach((applicant) => {
        // 根据身份名字获取身份编号
        const identity_id = applicant.material.identity_id;

        // 取出在映射中的结果
        const index = applicantIdentityAndIndexMap[identity_id];

        // 必须要保留0的情况
        if (index || index === 0) {
          // 将当前项加入到已经存在的身份的申请人列表中
          classifiedApplicants[index].applicants.push(applicant);
        } else {
          // 将此身份与classifiedApplicants中的下标对应
          applicantIdentityAndIndexMap[identity_id] = classifiedApplicants.length;

          // 将当前项加入  order.offline取反是因为线上订单是0
          classifiedApplicants.push(me.createIdentityData(identity_id, order, applicant, !order.offline));
        }
      });
    }
    return classifiedApplicants;
  },

  /**
   * 创建一个身份的资料数据对象
   * @param {Number} identity_id 身份编号
   * @param {Object} order 订单
   * @param {Object} applicant 申请人
   * @return {Object} 身份的赴馆数据对象
   */
  createIdentityData(identity_id, order, applicant) {
    const me = this;

    return {
      id: identity_id,
      identity: applicant.identity,
      applicants: [applicant], // 申请人列表
      materials: me.createApplicantMaterialArr(applicant.material),
    };
  },

  /**
   * 根据单个申请人创建当前申请人的身份所需的资料对象
   * @param {Object} identityMaterial 当前身份所需资料
   * @return {Object} 资料对象
   * @memberof SFService
   */
  createApplicantMaterialArr(identityMaterial) {
    const me = this;

    let simpleMaterials = [];
    simpleMaterials = simpleMaterials.concat(me.requiredOrOptionalMaterial(identityMaterial.material_required, true));
    simpleMaterials = simpleMaterials.concat(me.requiredOrOptionalMaterial(identityMaterial.material_optional, false));

    return me.sortMaterial(simpleMaterials);
  },

  /**
   * 处理必需或者可选资料
   *
   * @param {any} requiredOrOptional 可选或者必选资料
   * @param {Boolean} required 必备
   * @returns {Array}
   * @memberof SFService
   */
  requiredOrOptionalMaterial(requiredOrOptional, required) {
    const me = this;
    const materials = [];

    if (requiredOrOptional && requiredOrOptional.length > 0) {
      requiredOrOptional.forEach((material) => {
        // 纸质资料都要邮寄
        if (material.attr === 1) {
          materials.push(me.createMaterial(material, required));
        }
      });
    }

    return materials;
  },

  /**
   * 创建资料迭代对象
   * @param {any} material 资料
   * @param {Boolean} required 必备
   * @memberof SFService
   */
  createMaterial(material, required) {
    return {
      name: material.paper_name,
      required,
      attr: material.attr,
      template: material.template,
      sample: material.sample,
      attention: material.attention,
    };
  },

  /**
  * 1.必选电子资料
  * 2.必需纸质资料
  * 3.可选电子资料
  * 4.可选邮寄资料
  * @param {Array} simpleMaterials
  */
  sortMaterial(simpleMaterials) {
    const requireElec = [];
    const requiedPapery = [];
    const optionalElec = [];
    const optionalPapery = [];

    simpleMaterials.forEach((material) => {
      if (material.attr === 1) {
        if (material.required) {
          requiedPapery.push(material);
        } else {
          optionalPapery.push(material);
        }
      } else if (material.required) {
        requireElec.push(material);
      } else {
        optionalElec.push(material);
      }
    });

    return requireElec.concat(requiedPapery).concat(optionalElec).concat(optionalPapery);
  },

  /**
   * 判断所有申请人是否含有纸质资料
   *
   * @param {any} applicant 申请人数组
   * @returns {Boolean} 是否有纸质资料
   */
  isPaperMaterialIncluded(applicant) {
    let materialArr = [];
    applicant.forEach((applicant) => {
      materialArr = [...materialArr, ...applicant.material.material_optional, ...applicant.material.material_required];
    });
    return materialArr.some(element => element.attr === 1);
  },

  /**
   * 获取顺丰地址
   *
   * @param {Object} order 订单
   * @param {Array} addresses 地址数组
   * @returns {Object} 顺丰地址
   */
  getSfAddress(order, addresses) {
    if (!order.order_pickup || !addresses.length) {
      return {};
    }

    const pickupAddress = order.order_pickup[0].address;

    const sfAddress = addresses.filter(address => [
      'province_code',
      'city_code',
      'county_code',
      'detail_address',
      'addressee',
      'mobile_phone',
    ].every(key => address[key] === pickupAddress[key]))[0];

    return sfAddress || {};
  },
};




// WEBPACK FOOTER //
// ./src/services/sf-service.js